export enum ActivityType {
  INTRODUCTION = 'introduction',
  SHORT_REFLECTION = 'short_reflection',
  LONG_REFLECTION = 'long_reflection',
  SHORT_GAME = 'short_game',
  LONG_GAME = 'long_game',
  FIRST_GAME = 'first_game'
}
